<template>
  <el-container direction="vertical">
    <el-main>
      <el-row :gutter="20">
        <!-- <el-col :span="13" :sm="24" :md="13" :xs="24"> -->
        <el-col :span="24">
          <el-form
            ref="el_form"
            :model="model"
            label-position="left"
            size="mini"
            label-width="120px"
          >
            <el-row type="flex column">
              <el-col>
                <template v-if="isView">
                  <!-- <el-badge
                    :value="model.Phase.Name"
                    class="item"
                    type="primary"
                  >
                    <h2>{{ model.Name }}</h2>
                  </el-badge> -->

                  <el-tooltip
                    effect="dark"
                    content="Fase"
                    placement="top-start"
                    :disabled="!model.Phase.Name"
                  >
                    <el-tag type="success" v-if="model.Phase.Name">{{
                      model.Phase.Name
                    }}</el-tag>
                  </el-tooltip>
                </template>
                <template v-else>
                  <el-form-item label="Nombre" prop="Name">
                    <el-input
                      v-model="model.Name"
                      :disabled="isView"
                      autofocus
                    ></el-input>
                  </el-form-item>
                </template>
              </el-col>
            </el-row>

            <div style="width: 300px; height: 10px">
              <el-progress
                :percentage="
                  model.Phase !== undefined ? model.Phase.Percentaje : 0
                "
              ></el-progress>
            </div>

            <el-row :gutter="20" class="mt-20" type="flex column">
              <el-col :span="8" :xs="24" :sm="24" :md="24" :lg="12">
                <!-- selector de prospecto -->
                <el-form-item
                  label="Prospecto"
                  prop="ContactName"
                  v-if="showProspect || (showProspect && isView)"
                >
                  <el-select
                    v-model="model.CustomerCode"
                    clearable
                    filterable
                    reserve-keyword
                    remote
                    placeholder="Seleccionar o buscar prospecto"
                    v-loading="loadingProspect"
                    :disabled="isView"
                    :remote-method="remoteMethodProspect"
                    @change="handleChangeProspect"
                  >
                    <el-option
                      v-for="(item, index) in listProspects"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>

                <!-- Selector de cliente -->
                <el-form-item
                  label="Cliente"
                  prop="ContactName"
                  v-if="showClient || (showClient && isView)"
                >
                  <el-select
                    v-model="model.CustomerCode"
                    v-loading="loading_customers"
                    clearable
                    filterable
                    reserve-keyword
                    placeholder="Seleccionar o buscar cliente"
                    :disabled="!isView"
                    @change="handleChangeCustomer"
                  >
                    <el-option
                      v-for="(item, index) in list_customers"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>

                <!-- Contacto del prospecto o del cliente -->
                <el-form-item label="Contacto" prop="ContactDocument">
                  <el-select
                    v-model="model.ContactDocument"
                    v-loading="loadingContact"
                    clearable
                    filterable
                    reserve-keyword
                    placeholder="Seleccionar o buscar el contacto"
                    :disabled="controlerViewEdit"
                  >
                    <el-option
                      v-for="(item, index) in listContact"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="Contrato" prop="ContractTimeID">
                  <el-select
                    v-model="model.ContractTimeID"
                    v-loading="loading"
                    clearable
                    placeholder="Seleccionar contrato"
                    filterable
                    :disabled="controlerViewEdit"
                  >
                    <el-option
                      v-for="item in list_times"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                      :disabled="!item.IsEnabled"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="8" :xs="24" :sm="24" :md="24" :lg="12">
                <el-form-item label="Servicio" prop="DealsTypeID">
                  <el-select
                    v-model="model.DealsTypeID"
                    v-loading="loading"
                    clearable
                    placeholder="Tipo de servicio"
                    :disabled="controlerViewEdit"
                  >
                    <el-option
                      v-for="item in list_deal_of_types"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                      :disabled="!item.IsEnabled"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Modena" prop="CurrencyID">
                  <el-select
                    v-model="model.CurrencyID"
                    clearable
                    placeholder="Moneda"
                    v-loading="loading"
                    :disabled="controlerViewEdit"
                  >
                    <el-option
                      v-for="item in list_currency"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                      :disabled="!item.IsEnabled"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="Fecha de cierre" prop="FinalDate">
                  <el-date-picker
                    v-model="model.FinalDate"
                    type="date"
                    placeholder="Fecha de cierre"
                    format="yyyy/MM/dd"
                    :disabled="controlerViewEdit"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>

            <hr class="secondary-text" />

            <div class="deal-footer">
              <div class="flex reverse">
                <table class="box" contenteditable="false">
                  <tbody>
                    <tr>
                      <td id="total_unit">
                        <el-form-item
                          prop="UnitPrice"
                          size="mini"
                          label="Prec. unitario"
                        >
                          <el-input-number
                            v-model="model.UnitPrice"
                            :min="0"
                            :disabled="controlerViewEdit"
                          ></el-input-number>
                        </el-form-item>
                      </td>
                    </tr>
                    <tr>
                      <td id="total_qty">
                        <el-form-item
                          label="Cantidad"
                          prop="Quantity"
                          size="mini"
                        >
                          <el-input-number
                            v-model="model.Quantity"
                            :min="0"
                            :disabled="controlerViewEdit"
                          ></el-input-number>
                        </el-form-item>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label for=""><strong>Total:</strong></label>
                        <span id="total_price" style="float: right">{{
                          model.Amount
                        }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <el-form-item label="" label-width="0">
              <el-button v-if="!isView" type="primary" @click="onSubmit">{{
                buttonTitle
              }}</el-button>
              <el-button @click="onClose">Cancel</el-button>
            </el-form-item>
          </el-form>
        </el-col>

        <!-- <el-col :span="10" :offset="1" :sm="23" :md="10" :xs="23">
          <el-tabs v-model="activeName">
            <el-tab-pane name="comments">
              <span slot="label"
                ><i class="el-icon-chat-dot-round"></i> Comantarios</span
              >
              <comment-list />
            </el-tab-pane>
          </el-tabs>
        </el-col> -->
      </el-row>
    </el-main>
  </el-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Deal from "@/models/deals/Deal";

export default {
  name: "DealFormContainer",
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    isView: {
      type: Boolean,
      default: false
    },
    commants: {
      type: Array,
      default: () => []
    },
    initModel: {
      type: Object,
      required: false,
      default: () => {}
    },
    isProspect: {
      type: Boolean,
      default: false
    },
    isClient: {
      type: Boolean,
      default: false
    },
    currentClient: {
      type: Object,
      required: false
    },
    fromAction: {
      type: Boolean,
      default: false
    },
    code: {
      type: String,
      default: null,
      required: false
    }
  },
  data() {
    return {
      loadingProspect: false,
      loadingContact: false,
      activeName: "comments",
      // True si el cliente viene seleccionado desde la accion de cliente.
      disableCustomerName: false,
      loading: false,
      model: Deal,
      rules: {
        Name: [{ required: true }],
        ContactDocument: [{ required: true }]
      }
    };
  },
  async created() {
    await this.fetchCustomers();

    this.model = this.initModel;

    if (this.code !== null) {
      this.loadingContact = true;
      if (this.isProspect) {
        await this.getByProspectCode({
          contactCode: this.code
        });
        this.loadingContact = false;
      } else {
        await this.getByCustomerCode({
          customerCode: this.code
        });
        this.loadingContact = false;
      }
    }
  },
  methods: {
    ...mapGetters({
      getCurrency: "currency/getById",
      getCustomerByName: "customers/getCustomerByName"
    }),
    ...mapActions({
      createDeal: "deals/create",
      fetchCustomers: "customers/getCustomers",
      searchProspect: "prospects/searchProspects",
      getByProspectCode: "contact/getByProspectCode",
      getByCustomerCode: "contact/getByCustomerCode"
    }),
    handleChangeProspect(val) {
      if (val !== "") {
        this.loadingContact = true;

        this.getByProspectCode({
          contactCode: val
        }).then(() => {
          this.loadingContact = false;
        });
      } else {
        this.$store.commit("contact/list", []);
      }
    },
    handleChangeCustomer(val) {
      if (val !== "") {
        this.loadingContact = true;

        this.getByCustomerCode({ customerCode: val }).then(
          () => (this.loadingContact = false)
        );
      } else {
        this.$store.commit("contact/list", []);
      }
    },
    onSubmit() {
      this.$refs.el_form.validate((valid) => {
        if (valid) {
          if (!this.model.Amount) {
            this.$message.error("El monto es requerido");
            return false;
          }

          const user_id = this.currentUser.UserID;

          this.model.PhaseID = 1;
          this.model.CompanyID = this.currentCompany;
          this.model.ContactName = this.listContact.find(
            (c) => c.ContactCode === this.model.ContactDocument
          ).FullName;
          this.model.CreatedBy = user_id;
          this.model.ResponsibleID = user_id;
          this.model.UpdatedBy = user_id;

          // Si no es prospecto quiere decir que es un cliente por tanto buscamos el codigo en el selector.
          /* if (!this.isProspect) {
            this.model.CustomerCode = this.currentClient.ClientCode;
          } */

          this.createDeal(this.model)
            .then((resp) => {
              this.$emit("deal-created", "success", resp);
            })
            .catch((error) => {
              this.$emit("deal-created", "error", error);
            });
        } else {
          return false;
        }
      });
    },
    onClose() {
      this.$emit("close-form-deal");
    },
    remoteMethodProspect(query) {
      if (query !== "") {
        this.loadingProspect = true;
        setTimeout(() => {
          this.searchProspect({ search: query }).then(
            () => (this.loadingProspect = false)
          );
        }, 200);
      }
    }
  },
  computed: {
    ...mapGetters({
      list_currency: "currency/list_to_select",
      list_times: "times/list_to_select",
      list_deal_of_types: "deal_of_type/list_to_select",
      list_customers: "customers/list_to_select",
      loading_customers: "customers/isLoading",
      listProspects: "prospects/listProspects",
      listContact: "contact/listContact"
    }),
    amount() {
      let total = this.model.UnitPrice * this.model.Quantity;
      total = total ? total : 0;

      // if (this.model.CurrencyID) {
      //   const cu = this.$store.getters["currency/getById"](
      //     this.model.CurrencyID
      //   );
      //   total = `${cu.Name} ${total}`;
      // }
      return total;
    },
    showProspect() {
      if (this.isProspect && this.fromAction) {
        return false;
      }

      if (this.isProspect) {
        return true;
      }

      return false;
    },
    showClient() {
      if (this.isClient && this.fromAction) {
        return false;
      }

      if (this.isClient) {
        return true;
      }
      return false;
    },
    controlerViewEdit() {
      if (!this.isView && this.isEdit) {
        return false;
      }

      return this.isView || this.isEdit;
    },
    buttonTitle() {
      if (this.isEdit) return "Guardar";
      return "Crear";
    }
  },
  watch: {
    amount(val) {
      this.model.Amount = val;
    },
    code(val) {
      if (this.isProspect) {
        this.getByProspectCode({
          contactCode: val
        });
      } else {
        this.getByCustomerCode({
          customerCode: val
        });
      }
    },
    initModel(val) {
      this.model = val;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables";

.deal-footer {
  margin: 1rem;

  table {
    width: 25%;
    border-collapse: collapse;
    border-spacing: 0;

    tr:nth-child(2) td {
      padding-top: 0;
    }
    tr:last-child {
      border-top: 1px solid $text-color-info;
    }

    #total_price {
      font-size: 1.5rem;
      color: $text-color-accent;
    }
  }
}
</style>
